import Vue from "vue";
import chamaileonFrontendUtils from "@edmdesigner/chamaileon-frontend-utils";
import i18n from "@/plugins/i18n";

export default function () {
	return {
		namespaced: true,
		state: {
			name: null,
			environmentList: [],
			toRedirectAfterEnvSelect: {},
		},
		mutations: {
			SET_ENVIRONMENT_NAME(state, envName) {
				state.name = envName;
			},
			SET_REDIRECT_AFTER_ENV_SELECT(state, toRedirectAfterEnvSelect) {
				state.toRedirectAfterEnvSelect = toRedirectAfterEnvSelect;
			},
			ADD_TO_ENVIRONMENT_LIST(state, env) {
				state.environmentList.push(env);
			},
		},
		actions: {
			async setEnvironmentName({ commit }, envName) {
				if (envName && typeof envName === "string") {
					const environmentConfigUrl = ((envName.includes("dev")) ? "http://localhost:50004/configs/%ENVNAME%.json" : "https://config.chamaileon.io/%ENVNAME%.json");
					const chamaileonEnvironmentConfig = await chamaileonFrontendUtils.loadEnvironmentConfig({ environmentConfigUrl, environmentName: envName });

					Vue.prototype.$chamaileon.environmentConfig = chamaileonEnvironmentConfig;
				}
				commit("SET_ENVIRONMENT_NAME", envName);
			},
			async getEnvironmentList({ commit, dispatch }) {
				try {
					const response = await fetch("https://environments.prod.chamaileon.io/environment-names", {
						method: "GET",
					});

					const { result, error = null } = await response.json();

					if (error) throw new Error(error.code);

					const environmentList = result.items;
					// environmentList.push({ name: "dev" });
					environmentList.forEach((env) => {
						env.hasDeprecated = !!(env.deprecated || []).length;
						commit("ADD_TO_ENVIRONMENT_LIST", env);
					});
				} catch (error) {
					const translationExists = i18n.te(`environment.errorMessages.${error.message}`);
					const code = translationExists ? error.message : "networkError";
					dispatch("logger/logError", {
						id: Date.now(),
						handled: true,
						code,
						source: "backend",
						stack: error,
						notification: i18n.t(`environment.errorMessages.${code}`),
					}, { root: true });
					return;
				}
			},
		},
	};
}
